module.exports = __webpack_public_path__ + "img/2025-01-09a_3.373a56e6.jpg";